import React, { FC, PropsWithChildren } from 'react';

import { LocationProvider } from '@adsk/acc-locations-components';
import { useCurrentProjectId } from '@adsk/alloy-provider';

import { SearchContextProvider } from './SearchContext';

const AssetsProvider: FC<PropsWithChildren> = ({ children }) => (
  <LocationProvider projectId={useCurrentProjectId()}>
    <SearchContextProvider>{children}</SearchContextProvider>
  </LocationProvider>
);

export default AssetsProvider;
